import { type FC } from 'react';
import BooleanSelectBox from 'components/molecules/boolean-select-box';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { Filters } from 'infrastructure/hooks/interactiveTimeDashboard/types';

interface IProps {
  filters: Filters;
  onChange: (e?: boolean) => void;
}

const ReadingCountFilter: FC<IProps> = ({ onChange, filters }) => {
  const { t } = useTranslation();

  return (
    <div className={s['available-billable-minutes-wrapper']}>
      <label data-cy="interactiveTimeDashboard-filter-filterByReadings">
        {t('labels.filterByReadings')}
      </label>
      <BooleanSelectBox
        withAll
        placeholder={t('labels.all')}
        trueLabel={t('labels.totalWithReadings')}
        falseLabel={t('labels.totalNoReadings')}
        value={filters.withReading}
        onChange={onChange}
        allowClear
      />
    </div>
  );
};

export default ReadingCountFilter;
